import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@breakroom-nx/redux';

interface RegisterPaneState {
  paneStack: string[];
}

const initialState: RegisterPaneState = {
  paneStack: ['Welcome'],
};

export const registerSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    flipToPane: (state, action: PayloadAction<string>) => {
      const paneType: string = action.payload;
      // console.log(`PaneType: ${paneType}`);
      state.paneStack.push(paneType);
      // console.log(`Pane Stack: ${state.paneStack}`);
    },
    goBack: (state) => {
      state.paneStack.pop();
      // console.log(`Pane Stack: ${state.paneStack}`);
    },
  },
});

export const { flipToPane, goBack } = registerSlice.actions;
export const getRegisterState = (state: RootState) => state.register.paneStack;
export default registerSlice.reducer;
